import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { IUser } from 'projects/common/src/app/interfaces';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommunicationService } from 'src/app/services/communication';
import { IReportDownloadHistory } from '../interfaces/report-download-history';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable()
export class ReportInterceptorService implements HttpInterceptor {
  private baseUrl: string;
  constructor(
    private communicationService: CommunicationService,
    private parameterService: ParameterHandlerService,
    private languageService: LanguageService,
    private urlBuilderService: UrlBuilderService,
  ) {
    this.baseUrl = `${this.urlBuilderService.apiUrl}/`;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // All HTTP requests are going to go through this method
    let startDate: string;
    let endDate: string;
    if (req.url.includes('Report') && req.url.includes('Document') && !req.url.includes('Info')) {
      startDate = moment().format('YYYY-MM-DD HH:mm:ss');
      let reportNameCall: string[];
      let reportName: string;
      if (req.url.includes('?')) {
        const auxReportName = req.url.split('?');
        reportNameCall = auxReportName[0].split('/');
        reportName = reportNameCall[reportNameCall.length - 1].toString();
      } else {
        reportNameCall = req.url.split('/');
        reportName =
          reportNameCall[reportNameCall.length - 1] === ''
            ? reportNameCall[reportNameCall.length - 2].toString()
            : reportNameCall[reportNameCall.length - 1].toString();
      }

      reportName = reportName.replace('Get', '');
      reportName = reportName.replace('Document', '');
      reportName = this.languageService.message(reportName);
      const user = this.parameterService.parameters.item('user-data').value as IUser;
      return next.handle(req).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.ok) {
            endDate = moment().format('YYYY-MM-DD HH:mm:ss');
            const params: IReportDownloadHistory = {
              reportName,
              userId: user.id,
              downloadStartedAt: startDate,
              downloadFinishedAt: endDate,
            };
            this.insertReportDownloadHistory(params);
          }
          return event;
        }),
      );
    }
    return next.handle(req);
  }

  public insertReportDownloadHistory(params: IReportDownloadHistory): Promise<any> {
    const url = `${this.baseUrl}Report/InsertReportDownloadHistory`;
    return this.communicationService.post(url, null, params).toPromise();
  }
}
